import { useEffect, useState, memo } from "react";

import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

export const GraficoTecelagemSetup = memo(function GraficoTecelagemSetup({ data, month, months = [], setor }) {
    const [chartData, setChartData] = useState({});

    const options = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'center',
                align: 'center',
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 }).format(value);
                },
                font: {
                    size: 14,
                    weight: 'bold',
                },
                color: "#2c3e50",

            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true
            }
        }
    }

    useEffect(() => {
        if (setor === 'Tecelagem') {
            let labels = [];

            let producaoTecelagem = data.producao_geral;
            let setupTecelagem = data.setups;
            let residuosSetup = data.residuos_setup;

            if(residuosSetup.length > 0) {
                residuosSetup = [residuosSetup[0]];
            }

            let datasetTrama = { label: 'PRODUÇÃO DE RESÍDUOS (TRAMA)', data: [], backgroundColor: "#feca57" };
            let datasetUrdume = { label: 'PRODUÇÃO DE RESÍDUOS (URDUME)', data: [], backgroundColor: "#ff9ff3" };

            months.forEach((month, index = 1) => {
                let totalGeral = 0;

                let dadosMes = producaoTecelagem.filter((el) => { return parseInt(el.mes) === index });
                let total = 0;
                dadosMes.forEach((item) => {
                    total += !isNaN(parseFloat(item.pesoresiduos)) ? parseFloat(item.pesoresiduos) : 0;
                });

                totalGeral += total;

                datasetTrama.data.push(total);

                let dadosSetupMes = setupTecelagem.filter((el) => { return parseInt(el.mes) === index });
                total = 0;
                residuosSetup.forEach((residuo) => {
                    dadosSetupMes.forEach((item) => {
                        if (item.pesourdume !== null) {
                            total += item.qtd * parseFloat(item.pesourdume) * parseFloat(residuo.perda_metragem_por_rolo);
                        }
                    });
                });

                totalGeral += total;

                datasetUrdume.data.push(total);

                labels.push([month, parseInt(totalGeral)])
            });

            setChartData({ labels: labels, datasets: [datasetTrama, datasetUrdume] });
        }
    }, [data, month, months, setor]);

    if (setor !== 'Tecelagem')
        return null;

    return (
        <div className="col-12">
            <Chart
                data={chartData}
                options={options}
                plugins={[ChartDataLabels]}
                height="600px"
                type="bar"
                width="100%"
            />
        </div>
    )
});